'use client';
import { Suspense } from 'react';
import NotFoundComponent from '../components/NotFoundComponent';
import { SchemeProvider } from '@osmosis/react-ui/context/SchemeContext';
import StyledComponentsRegistry from './registry';
import { IntlProvider } from 'react-intl';

/**
 * Displays 404 page.
 */
const NotFoundPage = () => {
  return (
    <StyledComponentsRegistry>
      <SchemeProvider scheme="light">
        <IntlProvider locale="en">
          <Suspense>
            <NotFoundComponent />
          </Suspense>
        </IntlProvider>
      </SchemeProvider>
    </StyledComponentsRegistry>
  );
};

export default NotFoundPage;
